import React, { Component } from "react";

//components
import CustomButton from "../../../../generic_components/components/buttons/CustomButton";

//generic functions
import {
    isEmpty,
    cloneObject
} from "../../../../functions/generic_functions"

//redirect with javascript to a link
import { withRouter } from 'react-router-dom';

//import static routes
import {
    cari_app_form_url,
    cari_app_form_pg_submitted_url,
    cari_api_save_form_page_base_url,
    cari_api_verify_application_url,
    cari_api_submit_application_url
} from "../../../../router/static_routes";


//redux
import { connect } from "react-redux";
import {
    setCariFormActiveApplicationData,
    openCariModal,
    resetCariActiveData,
    setCariActiveUserData
} from "../../../../redux/actions/indexActions";

//redux mappers
const mapStateToProps = state => {
    return {
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData,
        activeUserData: state.cariReducer.activeUserData,
        activePositionData: state.cariReducer.activePositionData,
        activeApplicationData: state.cariReducer.activeApplicationData,
        cariPage1Data: state.cariReducer.cariPage1Data,
        cariPage2Data: state.cariReducer.cariPage2Data,
        cariPage3Data: state.cariReducer.cariPage3Data,
        cariPage4Data: state.cariReducer.cariPage4Data,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        setCariFormActiveApplicationData: (application_data) => {
            dispatch(setCariFormActiveApplicationData(application_data));
        },
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
        setCariActiveUserData: (user_data) => {
            dispatch(setCariActiveUserData(user_data))
        },
    };
};

/*
    props:
        page_num: the current page of cari form
        postData => postData json, all post data for this page
*/
class CariAppFormNavBtnBar extends Component {

    state = {
        mounted: false,
    }

    constructor(props) {
        super(props);

        //action handlers
        this.handleOnClickVerifyApplicationData = this.handleOnClickVerifyApplicationData.bind(this);

        //submit application
        this.submitApplication = this.submitApplication.bind(this);

        //helper functions
        this.getBackClickUrl = this.getBackClickUrl.bind(this);
        this.getForwardClickUrl = this.getForwardClickUrl.bind(this);

        //render components
        this.renderBackBtn = this.renderBackBtn.bind(this);
        this.renderForwardBtn = this.renderForwardBtn.bind(this);

        //api calls
        this.handleOnClickSavePageData = this.handleOnClickSavePageData.bind(this);
    }

    /*
        post cari page data and redirect to past or previous page
    */
    /*
        post parameters {
            application_id,
            email,
            token, //TODO remove after,
            postData,
        }

        return data {
            status => true/false
            message {
                saveComplete = true/false
            }
        }
    */
    handleOnClickSavePageData(subsequentUrl) {

        var currentPageNum = this.props.page_num;

        //if the application completion status is "Complete", skip save page
        if (this.props.activeApplicationData.application_status === "Complete") {
            this.props.history.push(subsequentUrl);
            return;
        }

        //if page 3, skip and go to next link
        if(currentPageNum === 3) {
            //redirect to next page
            this.props.history.push(subsequentUrl);
            return;
        }

        //retrieve data from redux store
        var cariPageDataCopy = null;
        switch (currentPageNum) {
            case 1:
                cariPageDataCopy = this.props.cariPage1Data;
                break;
            case 2:
                cariPageDataCopy = this.props.cariPage2Data;
                break;
            case 3:
                cariPageDataCopy = this.props.cariPage3Data;
                break;
            case 4:
                cariPageDataCopy = this.props.cariPage4Data;
                break;
            default:
        }

        if (!isEmpty(cariPageDataCopy)) {
            this.saveCurrentPage(cariPageDataCopy, currentPageNum, () => this.props.history.push(subsequentUrl));            
        }
        else {
            //if the api is not found, pop up a modal to show error message
            this.props.openCariModal({
                modalId: "errorModal",
                title: "Failed to retrieve data, please try again.",
            });
        }
    }

    saveCurrentPage(cariPageDataCopy, currentPageNum, callback=undefined) {
        //remove page num from post data
        delete cariPageDataCopy['page_num'];

        //post url
        var savePageDataUrl = cari_api_save_form_page_base_url + currentPageNum;

        //get email and application id and post data to post 
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentApplicationId = this.props.activeApplicationData.application_id;
        var currentToken = this.props.activeVerifiedLoginUserData.token;

        //set post data and add email, token and application id
        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);
        form_data.append("postData", JSON.stringify(cariPageDataCopy));

        var usedOwnEmailAsReference = false;

        for(var i = 0; i < cariPageDataCopy.length; i++) {
            if(cariPageDataCopy[i]['email'] == currentEmail) {
                usedOwnEmailAsReference = true;
            }
        }

        if(usedOwnEmailAsReference) {
            this.props.openCariModal({
                modalId: "errorModal",
                title: "Invalid Email Address",
                contentText: "You may not use your own email address for a reference. Please enter your reference's email address."
            });
        }
        else {
            //fetch page data from parameters
            fetch(savePageDataUrl, {
                method: 'POST',
                body: form_data,
                headers: {
                    'Accept': 'application/json',
                }
            }).then((response) => {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "User Session is invalid or has expired, please login again.",
                        callBackFuncOnOk: () => {
                            this.props.resetCariActiveData();
                        }
                    });
                }
            }).then(json => {
                //successfully processed request
                if (!isEmpty(json)
                    && !isEmpty(json.status)
                    && json.status 
                    && !isEmpty(JSON.parse(json.message))
                    && JSON.parse(json.message).saveComplete
                ) {
                    var json_data = JSON.parse(json.message);

                    //save first name and last name to redux store for active user data if it is the first page and the first name and last name is not empty
                    if (currentPageNum === 1
                        && !isEmpty(cariPageDataCopy.first_name)
                        && !isEmpty(cariPageDataCopy.last_name)
                    ) {
                        var copyUserActiveData = cloneObject(this.props.activeUserData);
                        copyUserActiveData.first_name = cariPageDataCopy.first_name;
                        copyUserActiveData.last_name = cariPageDataCopy.last_name;
                        this.props.setCariActiveUserData(copyUserActiveData);
                    }
                    if (typeof(callback) === typeof(Function)) {
                        callback();
                    }
                }
                //if api returns no data
                else {
                    // this.props.openCariModal({
                    //     modalId: "errorModal",
                    //     title: "Failed to save page data, please try again.",
                    // });
                }
            })
            //if api is not found
            .catch((error) => {
                console.log(error);
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Something went wrong, please try again.",
                });
            })
        }
    }

    getBackClickUrl() {
        var prevPage = cari_app_form_url + "/" + (this.props.page_num - 1);
        return prevPage;
    }

    getForwardClickUrl() {
        //checks if the page num is page 4, then set to submitted
        var nextPage = cari_app_form_url + "/invalid";

        if (this.props.page_num === 4) {
            nextPage = cari_app_form_url + '/submitted';
        }
        else {
            nextPage = cari_app_form_url + "/" + (this.props.page_num + 1);
        }
        return nextPage;
    }

    //handles the conditional rendering of the back and forward btns 
    renderBackBtn() {
        var backBtnName = "";
        if (!isEmpty(this.props.page_num)) {
            //build back button if it is NOT the first page 1
            if (this.props.page_num !== 1) { 

                backBtnName = "Back";
                return (
                    <CustomButton
                        type={"button"}
                        // icon={"arrow-left"}
                        label={backBtnName}
                        iconSize={"lg"}
                        className={"p-button-info pull_left"}
                        labelClassName={"back_btn_text_format"}
                        onClickSetParentState={() => this.handleOnClickSavePageData(this.getBackClickUrl())}
                    />
                );
            }
        }
    }

    renderForwardBtn() {
        var forwardBtnName = "";
        if (!isEmpty(this.props.page_num)) {
            //build forward button string if it is NOT the last page 4
            if (this.props.page_num !== 4) {

                forwardBtnName = "Continue";
                return (
                    <CustomButton
                        type={"submit"}
                        // icon={""}
                        iconLocation={"right"}
                        label={forwardBtnName}
                        iconSize={"lg"}
                        className={"p-button-info cari_navbar_btn_format pull_right"}
                        labelClassName={"cari_btn_text_format"}
                        onClickSetParentState={() => this.handleOnClickSavePageData(this.getForwardClickUrl())}
                    />
                );
            }

            //build the submit button with save icon if it is the last page AND the application status is not submitted
            else if (this.props.page_num === 4 
                && !isEmpty(this.props.activeApplicationData.application_status) 
                && 
                this.props.activeApplicationData.application_status !== "Complete") {
                forwardBtnName = "Submit";
                return (
                    <CustomButton
                        type={"submit"}
                        // icon={"save"}
                        iconLocation={"right"}
                        label={forwardBtnName}
                        iconSize={"lg"}
                        className={"p-button-success pull_right"}
                        labelClassName={"submit_btn_text_format"}
                        onClickSetParentState={() => {
                            this.saveCurrentPage(this.props.cariPage4Data, this.props.page_num, this.handleOnClickVerifyApplicationData());
                        }}
                    />
                );
            }
        }
    }

    /*
        pops up error modal message or confirmation on click of submit application
    */
   /*
        post parameters {
            email,
            application_id,
            token
        }
        return data {
            status = true/false,
            message {
                invalidPageNumStr = "", ie: "1,2,3";
                referencesForConsent: [
                    {
                        first_name,
                        last_name,
                    },
                    {
                        first_name,
                        last_name,
                    },
                ]
            }
        }
   */
    handleOnClickVerifyApplicationData() {

        // save page 4
        // this.handleOnClickSavePageData(this.getForwardClickUrl());

        //send api request to validate data

        //add email and application_id, token to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;

        // //set post data and add email, token and application id
        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);

        //post api to save data
        fetch(cari_api_verify_application_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "User Session is invalid or has expired, please login again.",
                        callBackFuncOnOk: () => {
                            this.props.resetCariActiveData();
                        }
                    });
                }
            }
        }).then(json => {
                //successfully processed request
                if (!isEmpty(json)
                    && !isEmpty(json.status)
                    && json.status 
                    && !isEmpty(JSON.parse(json.message))
                ) {
                    var json_data = JSON.parse(json.message);
                    
                    var invalidPageNumStr = json_data.invalidPageNumStr;

                    var referencesForConsent = json_data.referencesForConsent;
                    
                    var confirmationText = "<strong>Are you sure you want to submit your application?</strong>";

                    var contentData = {};
                    //check if reference contact data is true, append reference message to confirmation text
                    if (!isEmpty(referencesForConsent) && referencesForConsent) {
                        var referencesForConsentText = '<strong>Please Note:</strong> Automated reference request emails will be sent to your reference(s) and you will no longer be able to edit your reference information once you click "Submit" below.';

                        //save the references consent array to contentData
                        contentData['referencesForConsent'] = referencesForConsent;
                        contentData['referencesForConsentText'] = referencesForConsentText;
                    }
                    
     
                    //if the invalid page num str is null, there are no errors, open the modal for submit confirmation
                    if (isEmpty(invalidPageNumStr)) {
                        if (this.props.postData.direct_contact_referees_checkbox_val) {
                            this.props.openCariModal({
                                modalId: "submitConfirmationModal",
                                title: "Submit Application",
                                contentText: confirmationText,
                                contentData: contentData,
                                callBackFuncOnOk: () => { 
                                    this.submitApplication(); 
                                }
                            });
                        } else {
                            var contentText = "The application has missing or invalid data on the following pages: <strong>4</strong>.<br/>Please fill the pages out to submit the application.";

                            this.props.openCariModal({
                                modalId: "submitErrorModal",
                                title: "Incomplete Application",
                                contentText: contentText
                            });
                        }
                    }

                    //if the invalid page num str is not null, open modal for error pages for missing data
                    else {
                        var page4Valid = this.props.postData.direct_contact_referees_checkbox_val? "" : ", 4"
                        var contentText = "The application has missing or invalid data on the following pages: <strong>" + invalidPageNumStr + page4Valid + "</strong>.<br/>Please fill the pages out to submit the application.";

                        this.props.openCariModal({
                            modalId: "submitErrorModal",
                            title: "Incomplete Application",
                            contentText: contentText
                        });
                    }
                    
                }
                //if api returns no data
                else {
                    // this.props.openCariModal({
                    //     modalId: "errorModal",
                    //     title: "Failed to verify application data, please try again.",
                    // });
                }
            })
            //if api is not found
            .catch((error) => {
                console.log(error);
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Failed to connect to the server, please try again.",
                });
            })
    }

    //submit the application with api

    /*

        post parameters {
            email,
            application_id,
            token
        }

        return data {
            status: true/false,
            message {
                application_status: "", //values can be: "initial", "completed", or null by default(meaning not created yet)
            }
        }
    */
    submitApplication() {
        //send api call to submit application
        //add email and application_id, token to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;

        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);

        fetch(cari_api_submit_application_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "User Session is invalid or has expired, please login again.",
                        callBackFuncOnOk: () => {
                            this.props.resetCariActiveData();
                        }
                    });
                }
            }
        }).then(json => {
                //successfully processed request
                if (!isEmpty(json)
                    && !isEmpty(json.status)
                    && json.status 
                    && !isEmpty(JSON.parse(json.message))
                    && !isEmpty(JSON.parse(json.message).application_status)
                ) {
                    var json_data = JSON.parse(json.message);
                    var application_status = json_data.application_status;
                    if (application_status.toLowerCase() === "complete") {
                        //save the application status that is returned to redux store
                        this.props.setCariFormActiveApplicationData({ "application_id": currentApplicationId, "application_status": application_status});
                        //REDIRECT TO SUBMITTED PAGE TODO need call back on success redux save
                        this.props.history.push(cari_app_form_pg_submitted_url);
                    }
                    //failed to submit application
                    else {
                        this.props.openCariModal({
                            modalId: "errorModal",
                            title: "Failed to submit application, please try again.",
                        });
                    }
                }
                //if api returns no data
                else {
                    // this.props.openCariModal({
                    //     modalId: "errorModal",
                    //     title: "Failed to retrieve data, please try again.",
                    // });
                }
            })
            //if api is not found
            .catch((error) => {
                console.log(error);
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Failed to connect to the server, please try again.",
                });
            })
    }

    componentDidMount() {
        this.setState({
            mounted: true
        });
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    render() {
        return (
            <div>
                <div className="p-grid">
                    <div className="p-col-6">
                        {this.renderBackBtn()}
                    </div>
                    <div className="p-col-6">
                        {this.renderForwardBtn()}
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CariAppFormNavBtnBar));